import { useTranslation } from 'react-i18next'
import useHopTimusButton from './useHopTimusButton'
import { HopTimusButtonWrapper, HopTimusAvatar } from './styled-components'
import hopTimusAvatar from './hoptimus-avatar.png'

const HopTimusButton = () => {
  const { t } = useTranslation()
  const { isEnabled, isLoading, openWidget } = useHopTimusButton()

  if (!isEnabled) return null

  return (
    <HopTimusButtonWrapper
      id='hop-timus-button'
      type='button'
      disabled={isLoading}
      onClick={openWidget}
      title={t('common:hop_timus_button')}
    >
      <HopTimusAvatar src={hopTimusAvatar} alt='' aria-hidden='true' />
      {t('common:hop_timus_button')}
    </HopTimusButtonWrapper>
  )
}

export default HopTimusButton
